import _taggedTemplateLiteral from "/home/buildagent/buildAgent/work/35e0d48fca3726c0/node_modules/next/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject;

import { media } from '@anm/styles/helpers';
import styled from 'styled-components';

var setSizeByProps = function setSizeByProps(_ref) {
  var _ref$size = _ref.size,
      size = _ref$size === void 0 ? 1160 : _ref$size,
      fullWidth = _ref.fullWidth;
  return fullWidth ? '100%' : "".concat(size, "px");
};

var containerOnDesktop = media.desktop(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  padding: 0 20px;\n"])));
var Container = styled.div.withConfig({
  componentId: "sc-1ibx895-0"
})(["padding:0;margin:0 auto;max-width:", ";", ";"], setSizeByProps, containerOnDesktop);
export default Container;